// framework
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
// me
import { IRootViewModel, ViewConfiguration } from "../models/models";
import TitleSummaryView from "./titleSummary/TitleSummaryView";
import TitleholdersView from "./TitleholdersView";
import WorkProgramView from "./workProgram/WorkProgramView";
import MemorialView from "./MemorialView";
import BlocksAndLocationsView from "./blocksAndLocations/BlocksAndLocationsView";

export enum TitleDetailsTabsEnum {
    Summary,
    Titleholders,
    WorkProgram,
    Memorial,
    BlocksAndLocations,
}

interface IProps {
    vm: IRootViewModel;
    preferredTab: TitleDetailsTabsEnum;
}

export default function DetailsView(props: IProps) {
    const { vm, preferredTab } = props;
    const vc = new ViewConfiguration(vm.titleType);

    return (
        <Tabs defaultActiveKey={preferredTab.toString()} variant="pills" mountOnEnter>
            {/* Summary Tab */}
            <Tab eventKey={TitleDetailsTabsEnum.Summary.toString()} title="Title Summary">
                <TitleSummaryView titleType={vm.titleType} summary={vm.summary} map={vm.map} />
            </Tab>

            {/* Titleholders Tab */}
            <Tab eventKey={TitleDetailsTabsEnum.Titleholders.toString()} title="Titleholders">
                <TitleholdersView titleholders={vm.titleholders} />
            </Tab>

            {/* Work Program Tab */}
            {vc.isWorkProgramVisible && (
                <Tab eventKey={TitleDetailsTabsEnum.WorkProgram.toString()} title="Work Program">
                    <WorkProgramView title2SubType={vm.title2SubType} title2SubTypeName={vm.title2SubTypeName} workProgram={vm.workProgram} />
                </Tab>
            )}

            {/* Memorial Tab */}
            <Tab eventKey={TitleDetailsTabsEnum.Memorial.toString()} title="Memorial">
                <MemorialView titleNumber={vm.titleNumber} memorial={vm.memorial} />
            </Tab>

            {/* Blocks & Locations Tab */}
            {vc.isBlocksAndLocationsTabVisible && (
                <Tab eventKey={TitleDetailsTabsEnum.BlocksAndLocations.toString()} title={vc.isLocationsDataVisible ? "Blocks & Locations" : "Blocks"}>
                    <BlocksAndLocationsView blocksAndLocations={vm.blocksAndLocations} isLocationsDataVisible={vc.isLocationsDataVisible} areaSqKm={vm.map?.areaSqKm} />
                </Tab>
            )}
        </Tabs>
    );
}
